import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.2",
  "description": "Turborepo 1.2는 향상된 작업 필터링, 아티팩트 서명 및 무결성, 사람이 읽을 수 있고 JSON 형식의 dry run 등을 도입합니다!",
  "date": "2022/04/08",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "1월 말 Turborepo v1.1을 출시한 이후, 놀라운 채택률과 커뮤니티 성장을 보였습니다:"
  }, {
    "heading": "",
    "content": "6.5k+ GitHub Stars"
  }, {
    "heading": "",
    "content": "140k+ 주간 npm 다운로드 (지난 v1.1 블로그 포스트 이후 2배 증가)"
  }, {
    "heading": "",
    "content": "95+ OSS 기여자"
  }, {
    "heading": "",
    "content": "900+ Turborepo Community Discord 회원"
  }, {
    "heading": "",
    "content": "1.6년의 시간 절약 - Vercel의 Remote Caching을 통해 매주 2.5개월 이상 절약"
  }, {
    "heading": "",
    "content": "Turborepo v1.2는 사용성, 관찰 가능성 및 보안을 더욱 개선했으며 다음 기능을 제공합니다:"
  }, {
    "heading": "",
    "content": "새로운 Task Filtering API: --filter가 turbo run에 더 강력한 작업 필터링 기능을 추가합니다"
  }, {
    "heading": "",
    "content": "사람이 읽을 수 있고 JSON 형식의 dry run: --dry-run 플래그로 작업을 실행하지 않고 turbo run에 대한 정보를 사람이 읽을 수 있고 JSON 파싱 가능한 형식으로 출력할 수 있습니다"
  }, {
    "heading": "",
    "content": "개선된 내부 스케줄러 및 그래프: turbo의 내부 스케줄러와 그래프를 리팩터링하여 더욱 인체공학적이고 예측 가능하게 만들었습니다"
  }, {
    "heading": "",
    "content": "향상된 Remote Cache 보안: 자체 비밀 키로 원격 캐시 아티팩트에 암호화 서명을 할 수 있습니다"
  }, {
    "heading": "",
    "content": "npm install turbo@latest를 실행하여 오늘 업데이트하세요. turbo run을 처음 실행하면 @turbo/codemod를 사용하여 v1.2에 대한 자동 마이그레이션을 실행하는 방법에 대한 지침이 표시됩니다."
  }, {
    "heading": "new-task-filtering-api",
    "content": "가장 많이 요청된 기능 중 하나인 --filter 플래그를 통한 표현력 있는 작업 필터링 기능을 출시하게 되어 기쁩니다. --filter 플래그는 현재 --scope, --include-dependencies, --since, --no-deps 플래그의 조합보다 훨씬 강력한 후속 기능입니다."
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter를 사용하면 이름, 폴더 또는 git commit ref 이후 변경 여부를 기준으로 모노레포에서 일치하는 패키지의 하위 집합으로만 명령 실행을 제한하도록 turbo에 지시할 수 있습니다."
  }, {
    "heading": "new-task-filtering-api",
    "content": "새로운 --filter 명령으로 수행할 수 있는 작업의 몇 가지 예를 살펴보세요:"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=<package_name> - 정확한 패키지 이름 또는 glob 패턴으로 일치"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=...<package_name> - 패키지 이름/glob으로 일치하고 일치하는 항목의 모든 의존 패키지 포함"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=...^<package_name> - 패키지 이름/glob으로 일치하고 일치하는 항목의 모든 의존 패키지를 포함하지만 일치하는 항목 자체는 제외"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=<package_name>... - 패키지 이름/glob으로 일치하고 일치하는 패키지의 모든 종속성 포함"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=<package_name>^... - 패키지 이름/glob으로 일치하고 일치하는 패키지 종속성을 모두 포함하지만 일치하는 항목 자체는 제외"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter={./path/to/package} - 경로 또는 파일시스템 glob 패턴으로 일치"
  }, {
    "heading": "new-task-filtering-api",
    "content": "--filter=[origin/main] - git commit ref 이후 변경된 패키지로 일치"
  }, {
    "heading": "new-task-filtering-api",
    "content": "여러 필터를 함께 사용하여 더욱 세분화된 필터링을 할 수 있으며, 위 패턴의 각 부분 {}, [], ^, ...를 결합하여 더 복잡한 동작을 표현할 수 있습니다."
  }, {
    "heading": "new-task-filtering-api",
    "content": "예를 들어, 로컬 패키지를 종속성으로 사용하는 ./apps/web 디렉터리에 앱이 있고, Turborepo 파이프라인에서 test가 위상적으로 ^build에 의존하는 경우 다음을 실행하면:"
  }, {
    "heading": "new-task-filtering-api",
    "content": "turbo에게 종속성이 빌드되었는지 확인하고 앱이 HEAD^1 이후 변경된 경우 ./apps/web에 위치한 앱 자체를 제외한 모든 로컬 종속성에서 test 스크립트를 실행하도록 지시합니다."
  }, {
    "heading": "new-task-filtering-api",
    "content": "자세한 내용과 예제는 새로운 필터링 문서를 참조하세요."
  }, {
    "heading": "debug-and-automate-with---dry-run",
    "content": "이제 turbo run 명령에 --dry-run 또는 --dry-run=json을 추가하여 실제로 명령을 실행하지 않고도 turbo run의 영향을 확인할 수 있습니다. 이는 사람이 읽을 수 있는 형식 또는 JSON 출력으로 결과를 제공합니다."
  }, {
    "heading": "debug-and-automate-with---dry-run",
    "content": "Dry run은 두 가지 상황에서 매우 유용합니다:"
  }, {
    "heading": "debug-and-automate-with---dry-run",
    "content": "실행 옵션 디버깅 및 테스트"
  }, {
    "heading": "debug-and-automate-with---dry-run",
    "content": "자동화 구축을 위한 turbo 필터링 및 작업 그래프 사용"
  }, {
    "heading": "debug-and-automate-with---dry-run",
    "content": "이를 통해 turbo가 수행하는 작업에 대한 가시성을 개선하고 디버깅 속도를 높이며 동적 CI/CD 시스템에서 turbo를 더 쉽게 활용할 수 있기를 바랍니다."
  }, {
    "heading": "improved-internal-scheduler-and-graph",
    "content": "turbo run을 사용할 때 모든 package.json 작업은 Turborepo pipeline에 정의된 추론된 관계를 기반으로 종속성을 매핑하기 위해 내부 그래프에 추가됩니다. 이 작업 그래프를 통해 Turborepo는 증분 동시 작업 실행을 효율적으로 스케줄링하고 나중에 사용할 작업 출력을 캐시할 수 있습니다."
  }, {
    "heading": "improved-internal-scheduler-and-graph",
    "content": "내부 작업 스케줄러와 결과 그래프 구조에 주요 개선 사항을 적용하여 성능과 개발자 경험을 개선했습니다. 예를 들어, 많은 경우 더 이상 --include-dependencies를 사용할 필요가 없습니다. 대신 작업 진입점을 지정한 후 새롭고 개선된 그래프가 자동으로 이 그래프 해결을 처리합니다."
  }, {
    "heading": "cache-outputs-integrity-and-signature-verification",
    "content": "이제 Turborepo를 구성하여 Remote Cache에 업로드하기 전에 비밀 키를 사용하여 HMAC-SHA256으로 원격 캐시 출력에 서명할 수 있습니다. Turborepo가 서명된 캐시 아티팩트를 다운로드하면 이제 아티팩트의 무결성과 진위성을 확인합니다. 확인에 실패한 아티팩트는 무시되고 폐기되며 Turborepo에서 캐시 미스로 처리됩니다."
  }, {
    "heading": "cache-outputs-integrity-and-signature-verification",
    "content": "이 기능을 활성화하려면 turbo.json 구성 파일의 remoteCache 옵션을 signature: true로 설정하세요. 그런 다음 TURBO_REMOTE_CACHE_SIGNATURE_KEY 환경 변수를 선언하여 비밀 키를 지정하세요."
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "--sso-team 플래그를 사용하면 이제 SAML 토큰이 있는 팀이 올바른 팀 권한으로 turbo login을 통해 로그인할 수 있습니다"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "--log-output 플래그를 사용하면 터미널에 인쇄되는 로그와 시기를 제어하여 새로운 것에만 집중할 수 있습니다"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "FORCE_COLOR 환경 변수가 이제 지원됩니다"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "TURBO_FORCE=true 환경 변수는 이제 강제 실행됩니다"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "--remote-only 및 TURBO_REMOTE_ONLY=true는 turbo에게 Remote Caching만 사용하도록 지시합니다"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "이제 하나 이상의 작업이 시도되면 >>> FULL TURBO를 표시합니다"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "Yarn v2+ with Plug'n'Play (PnP linker)가 turbo run 명령에 대해 지원되지만 turbo prune은 아직 완전히 지원되지 않습니다"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "--profile이 지정된 경우 chrome tracing 회귀 수정"
  }, {
    "heading": "other-bug-fixes-and-improvements",
    "content": "이제 --concurrency=50%로 CPU 비율로 동시성을 설정할 수 있습니다"
  }, {
    "heading": "were-hiring",
    "content": "Vercel의 Turborepo 팀이 채용 중입니다! 올해 이미 5명의 핵심 팀원이 있으며 더 많은 인원을 채용하고자 합니다. 특히 풀타임 Senior Build Systems Engineers를 찾고 있습니다."
  }, {
    "heading": "whats-next",
    "content": "원활한 점진적 채택/마이그레이션과 CI/CD 속도 향상과 함께 Turborepo의 일상적인 사용성, 보안 및 관찰 가능성을 개선하는 데 중점을 두고 있습니다. 새로운 --filter 플래그, 서명된 아티팩트 및 dry run은 이러한 목표를 향한 중요한 단계입니다."
  }, {
    "heading": "whats-next",
    "content": "다음으로는 향상된 로컬 개발 경험, 코드베이스 자동화 및 전반적인 CLI 성능에 중점을 둘 것입니다."
  }, {
    "heading": "thank-you-contributors",
    "content": "Turborepo는 95명 이상의 개별 개발자와 핵심 팀의 결합된 작업의 결과입니다."
  }, {
    "heading": "thank-you-contributors",
    "content": "이 릴리스는 다음의 기여로 제공되었습니다: @gsoltis09, @jaredpalmer, @gaspar09, @shuding, @rajatkulkarni95, @VanTanev, @Kikobeats, @tknickman, @thebanjomatic, @chelkyl, @elado, @finn-orsini, @becca, @weyert, @ekosz"
  }],
  "headings": [{
    "id": "new-task-filtering-api",
    "content": "New Task Filtering API"
  }, {
    "id": "debug-and-automate-with---dry-run",
    "content": "Debug and Automate with --dry-run"
  }, {
    "id": "improved-internal-scheduler-and-graph",
    "content": "Improved Internal Scheduler and Graph"
  }, {
    "id": "cache-outputs-integrity-and-signature-verification",
    "content": "Cache Outputs Integrity and Signature Verification"
  }, {
    "id": "other-bug-fixes-and-improvements",
    "content": "Other bug fixes and improvements"
  }, {
    "id": "were-hiring",
    "content": "We're hiring!"
  }, {
    "id": "whats-next",
    "content": "What's next?"
  }, {
    "id": "thank-you-contributors",
    "content": "Thank you, contributors"
  }]
};
import __img0 from "./../../public/images/blog/turbo-1-2-0/turbo-dry-run.png";
import {Date} from '#components/blog/date';
import {Authors} from '#components/authors';
export const toc = [{
  depth: 2,
  url: "#new-task-filtering-api",
  title: _jsx(_Fragment, {
    children: "New Task Filtering API"
  })
}, {
  depth: 2,
  url: "#debug-and-automate-with---dry-run",
  title: _jsxs(_Fragment, {
    children: ["Debug and Automate with ", _jsx("code", {
      children: "--dry-run"
    })]
  })
}, {
  depth: 2,
  url: "#improved-internal-scheduler-and-graph",
  title: _jsx(_Fragment, {
    children: "Improved Internal Scheduler and Graph"
  })
}, {
  depth: 2,
  url: "#cache-outputs-integrity-and-signature-verification",
  title: _jsx(_Fragment, {
    children: "Cache Outputs Integrity and Signature Verification"
  })
}, {
  depth: 2,
  url: "#other-bug-fixes-and-improvements",
  title: _jsx(_Fragment, {
    children: "Other bug fixes and improvements"
  })
}, {
  depth: 2,
  url: "#were-hiring",
  title: _jsx(_Fragment, {
    children: "We're hiring!"
  })
}, {
  depth: 2,
  url: "#whats-next",
  title: _jsx(_Fragment, {
    children: "What's next?"
  })
}, {
  depth: 2,
  url: "#thank-you-contributors",
  title: _jsx(_Fragment, {
    children: "Thank you, contributors"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.2"
    }), "\n", "\n", _jsx(Date, {
      children: "Friday, April 8th, 2022"
    }), "\n", _jsx(Authors, {
      authors: ['jaredpalmer', 'becca__z', 'gaspargarcia', 'gregsoltis']
    }), "\n", _jsx(_components.p, {
      children: "1월 말 Turborepo v1.1을 출시한 이후, 놀라운 채택률과 커뮤니티 성장을 보였습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "6.5k+"
        }), " ", _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "GitHub Stars"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "140k+"
        }), " 주간 npm 다운로드 (", _jsx(_components.a, {
          href: "/blog/turbo-1-1-0",
          children: "지난 v1.1 블로그 포스트"
        }), " 이후 2배 증가)"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "95+"
        }), " OSS 기여자"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "900+"
        }), " ", _jsx(_components.a, {
          href: "https://turborepo.com/discord",
          children: "Turborepo Community Discord"
        }), " 회원"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "1.6년"
        }), "의 시간 절약 - Vercel의 Remote Caching을 통해 매주 2.5개월 이상 절약"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo v1.2는 사용성, 관찰 가능성 및 보안을 더욱 개선했으며 다음 기능을 제공합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#new-task-filtering-api",
          children: _jsx(_components.strong, {
            children: "새로운 Task Filtering API"
          })
        }), ": ", _jsx(_components.code, {
          children: "--filter"
        }), "가 ", _jsx(_components.code, {
          children: "turbo run"
        }), "에 더 강력한 작업 필터링 기능을 추가합니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#debug-and-automate-with---dry-run",
          children: _jsx(_components.strong, {
            children: "사람이 읽을 수 있고 JSON 형식의 dry run"
          })
        }), ": ", _jsx(_components.code, {
          children: "--dry-run"
        }), " 플래그로 작업을 실행하지 않고 ", _jsx(_components.code, {
          children: "turbo run"
        }), "에 대한 정보를 사람이 읽을 수 있고 JSON 파싱 가능한 형식으로 출력할 수 있습니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#improved-internal-scheduler-and-graph",
          children: _jsx(_components.strong, {
            children: "개선된 내부 스케줄러 및 그래프"
          })
        }), ": ", _jsx(_components.code, {
          children: "turbo"
        }), "의 내부 스케줄러와 그래프를 리팩터링하여 더욱 인체공학적이고 예측 가능하게 만들었습니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#cache-outputs-integrity-and-signature-verification",
          children: _jsx(_components.strong, {
            children: "향상된 Remote Cache 보안"
          })
        }), ": 자체 비밀 키로 원격 캐시 아티팩트에 암호화 서명을 할 수 있습니다"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npm install turbo@latest"
      }), "를 실행하여 오늘 업데이트하세요. ", _jsx(_components.code, {
        children: "turbo run"
      }), "을 처음 실행하면 ", _jsx(_components.code, {
        children: "@turbo/codemod"
      }), "를 사용하여 ", _jsx(_components.code, {
        children: "v1.2"
      }), "에 대한 자동 마이그레이션을 실행하는 방법에 대한 지침이 표시됩니다."]
    }), "\n", _jsx(_components.h2, {
      id: "new-task-filtering-api",
      children: "New Task Filtering API"
    }), "\n", _jsxs(_components.p, {
      children: ["가장 많이 요청된 기능 중 하나인 ", _jsx(_components.code, {
        children: "--filter"
      }), " 플래그를 통한 표현력 있는 작업 필터링 기능을 출시하게 되어 기쁩니다. ", _jsx(_components.code, {
        children: "--filter"
      }), " 플래그는 현재 ", _jsx(_components.code, {
        children: "--scope"
      }), ", ", _jsx(_components.code, {
        children: "--include-dependencies"
      }), ", ", _jsx(_components.code, {
        children: "--since"
      }), ", ", _jsx(_components.code, {
        children: "--no-deps"
      }), " 플래그의 조합보다 훨씬 강력한 후속 기능입니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "--filter"
      }), "를 사용하면 이름, 폴더 또는 git commit ref 이후 변경 여부를 기준으로 모노레포에서 일치하는 패키지의 하위 집합으로만 명령 실행을 제한하도록 ", _jsx(_components.code, {
        children: "turbo"
      }), "에 지시할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["새로운 ", _jsx(_components.code, {
        children: "--filter"
      }), " 명령으로 수행할 수 있는 작업의 몇 가지 예를 살펴보세요:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=<package_name>"
        }), " - 정확한 패키지 이름 또는 glob 패턴으로 일치"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=...<package_name>"
        }), " - 패키지 이름/glob으로 일치하고 일치하는 항목의 모든 의존 패키지 포함"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=...^<package_name>"
        }), " - 패키지 이름/glob으로 일치하고 일치하는 항목의 모든 의존 패키지를 포함하지만 일치하는 항목 자체는 제외"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=<package_name>..."
        }), " - 패키지 이름/glob으로 일치하고 일치하는 패키지의 모든 종속성 포함"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=<package_name>^..."
        }), " - 패키지 이름/glob으로 일치하고 일치하는 패키지 종속성을 모두 포함하지만 일치하는 항목 자체는 제외"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter={./path/to/package}"
        }), " - 경로 또는 파일시스템 glob 패턴으로 일치"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--filter=[origin/main]"
        }), " - git commit ref 이후 변경된 패키지로 일치"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["여러 필터를 함께 사용하여 더욱 세분화된 필터링을 할 수 있으며, 위 패턴의 각 부분 ", _jsx(_components.code, {
        children: "{}"
      }), ", ", _jsx(_components.code, {
        children: "[]"
      }), ", ", _jsx(_components.code, {
        children: "^"
      }), ", ", _jsx(_components.code, {
        children: "..."
      }), "를 결합하여 더 복잡한 동작을 표현할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["예를 들어, 로컬 패키지를 종속성으로 사용하는 ", _jsx(_components.code, {
        children: "./apps/web"
      }), " 디렉터리에 앱이 있고, Turborepo 파이프라인에서 ", _jsx(_components.code, {
        children: "test"
      }), "가 위상적으로 ", _jsx(_components.code, {
        children: "^build"
      }), "에 의존하는 경우 다음을 실행하면:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "./apps/web}[HEAD^1]^..."
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "에게 종속성이 빌드되었는지 확인하고 앱이 HEAD^1 이후 변경된 경우 ", _jsx(_components.code, {
        children: "./apps/web"
      }), "에 위치한 앱 자체를 제외한 모든 로컬 종속성에서 ", _jsx(_components.code, {
        children: "test"
      }), " 스크립트를 실행하도록 지시합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용과 예제는 새로운 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks#using-filters",
        children: "필터링 문서"
      }), "를 참조하세요."]
    }), "\n", _jsxs(_components.h2, {
      id: "debug-and-automate-with---dry-run",
      children: ["Debug and Automate with ", _jsx(_components.code, {
        children: "--dry-run"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["이제 ", _jsx(_components.code, {
        children: "turbo run"
      }), " 명령에 ", _jsx(_components.code, {
        children: "--dry-run"
      }), " 또는 ", _jsx(_components.code, {
        children: "--dry-run=json"
      }), "을 추가하여 실제로 명령을 실행하지 않고도 ", _jsx(_components.code, {
        children: "turbo run"
      }), "의 영향을 확인할 수 있습니다. 이는 사람이 읽을 수 있는 형식 또는 JSON 출력으로 결과를 제공합니다."]
    }), "\n", _jsx(_components.p, {
      children: "Dry run은 두 가지 상황에서 매우 유용합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "실행 옵션 디버깅 및 테스트"
      }), "\n", _jsxs(_components.li, {
        children: ["자동화 구축을 위한 ", _jsx(_components.code, {
          children: "turbo"
        }), " 필터링 및 작업 그래프 사용"]
      }), "\n"]
    }), "\n", " ", "\n", _jsx("div", {
      className: "overflow-hidden lg:rounded-xl",
      children: _jsx(_components.p, {
        children: _jsx(_components.img, {
          alt: "Turborepo Dry Run",
          placeholder: "blur",
          src: __img0
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이를 통해 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 수행하는 작업에 대한 가시성을 개선하고 디버깅 속도를 높이며 동적 CI/CD 시스템에서 ", _jsx(_components.code, {
        children: "turbo"
      }), "를 더 쉽게 활용할 수 있기를 바랍니다."]
    }), "\n", _jsx(_components.h2, {
      id: "improved-internal-scheduler-and-graph",
      children: "Improved Internal Scheduler and Graph"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo run"
      }), "을 사용할 때 모든 ", _jsx(_components.code, {
        children: "package.json"
      }), " 작업은 Turborepo ", _jsx(_components.code, {
        children: "pipeline"
      }), "에 정의된 추론된 관계를 기반으로 종속성을 매핑하기 위해 내부 그래프에 추가됩니다. 이 작업 그래프를 통해 Turborepo는 증분 동시 작업 실행을 효율적으로 스케줄링하고 나중에 사용할 작업 출력을 캐시할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["내부 작업 스케줄러와 결과 그래프 구조에 주요 개선 사항을 적용하여 성능과 개발자 경험을 개선했습니다. 예를 들어, 많은 경우 더 이상 ", _jsx(_components.code, {
        children: "--include-dependencies"
      }), "를 사용할 필요가 없습니다. 대신 작업 진입점을 지정한 후 새롭고 개선된 그래프가 자동으로 이 그래프 해결을 처리합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "cache-outputs-integrity-and-signature-verification",
      children: "Cache Outputs Integrity and Signature Verification"
    }), "\n", _jsx(_components.p, {
      children: "이제 Turborepo를 구성하여 Remote Cache에 업로드하기 전에 비밀 키를 사용하여 HMAC-SHA256으로 원격 캐시 출력에 서명할 수 있습니다. Turborepo가 서명된 캐시 아티팩트를 다운로드하면 이제 아티팩트의 무결성과 진위성을 확인합니다. 확인에 실패한 아티팩트는 무시되고 폐기되며 Turborepo에서 캐시 미스로 처리됩니다."
    }), "\n", _jsxs(_components.p, {
      children: ["이 기능을 활성화하려면 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 구성 파일의 ", _jsx(_components.code, {
        children: "remoteCache"
      }), " 옵션을 ", _jsx(_components.code, {
        children: "signature: true"
      }), "로 설정하세요. 그런 다음 ", _jsx(_components.code, {
        children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
      }), " 환경 변수를 선언하여 비밀 키를 지정하세요."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"[https://turborepo.com/schema.json](https://turborepo.com/schema.json)\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"remoteCache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // 서명 확인이 활성화되었는지 여부를 나타냅니다."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"signature\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "other-bug-fixes-and-improvements",
      children: "Other bug fixes and improvements"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--sso-team"
        }), " 플래그를 사용하면 이제 SAML 토큰이 있는 팀이 올바른 팀 권한으로 ", _jsx(_components.code, {
          children: "turbo login"
        }), "을 통해 로그인할 수 있습니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--log-output"
        }), " 플래그를 사용하면 터미널에 인쇄되는 로그와 시기를 제어하여 새로운 것에만 집중할 수 있습니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "FORCE_COLOR"
        }), " 환경 변수가 이제 지원됩니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "TURBO_FORCE=true"
        }), " 환경 변수는 이제 강제 실행됩니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--remote-only"
        }), " 및 ", _jsx(_components.code, {
          children: "TURBO_REMOTE_ONLY=true"
        }), "는 ", _jsx(_components.code, {
          children: "turbo"
        }), "에게 Remote Caching만 사용하도록 지시합니다"]
      }), "\n", _jsxs(_components.li, {
        children: ["이제 하나 이상의 작업이 시도되면 ", _jsx(_components.code, {
          children: ">>> FULL TURBO"
        }), "를 표시합니다"]
      }), "\n", _jsxs(_components.li, {
        children: ["Yarn v2+ with Plug'n'Play (PnP linker)가 ", _jsx(_components.code, {
          children: "turbo run"
        }), " 명령에 대해 지원되지만 ", _jsx(_components.code, {
          children: "turbo prune"
        }), "은 아직 완전히 지원되지 않습니다"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--profile"
        }), "이 지정된 경우 chrome tracing 회귀 수정"]
      }), "\n", _jsxs(_components.li, {
        children: ["이제 ", _jsx(_components.code, {
          children: "--concurrency=50%"
        }), "로 CPU 비율로 동시성을 설정할 수 있습니다"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "were-hiring",
      children: "We're hiring!"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), "의 Turborepo 팀이 채용 중입니다! 올해 이미 5명의 핵심 팀원이 있으며 더 많은 인원을 채용하고자 합니다. 특히 풀타임 ", _jsx(_components.a, {
        href: "https://vercel.com/careers",
        children: "Senior Build Systems Engineers"
      }), "를 찾고 있습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "whats-next",
      children: "What's next?"
    }), "\n", _jsxs(_components.p, {
      children: ["원활한 점진적 채택/마이그레이션과 CI/CD 속도 향상과 함께 Turborepo의 일상적인 사용성, 보안 및 관찰 가능성을 개선하는 데 중점을 두고 있습니다. 새로운 ", _jsx(_components.code, {
        children: "--filter"
      }), " 플래그, 서명된 아티팩트 및 dry run은 이러한 목표를 향한 중요한 단계입니다."]
    }), "\n", _jsx(_components.p, {
      children: "다음으로는 향상된 로컬 개발 경험, 코드베이스 자동화 및 전반적인 CLI 성능에 중점을 둘 것입니다."
    }), "\n", _jsx(_components.h2, {
      id: "thank-you-contributors",
      children: "Thank you, contributors"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 95명 이상의 개별 개발자와 핵심 팀의 결합된 작업의 결과입니다."
    }), "\n", _jsx(_components.p, {
      children: "이 릴리스는 다음의 기여로 제공되었습니다: @gsoltis09, @jaredpalmer, @gaspar09, @shuding, @rajatkulkarni95, @VanTanev, @Kikobeats, @tknickman, @thebanjomatic, @chelkyl, @elado, @finn-orsini, @becca, @weyert, @ekosz"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
